var offline_mode = false; // true or false
var user_group_id = "868";
var user_group_name = "";
//var user_group_ua_property_id = "UA-601294-24"; // GA Linker - Variable
//var user_group_ua_property_id = "UA-143763325-8"; // GA Linker - Variable - Cross Domain Tracking
var offline_url = "https://fujifilm.co.nz";
var reimagine_url = "https://868.app.fujifilmimagine.com/";
//var domain_name = "rest.fujifilmimagine.com";

(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

ga('create', 'UA-XXXXX-Y', 'auto');
ga(function(tracker) {
  dataLayer.push({event:"ga_ready"});
}); 

function readCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
    }
    return null;
}

function getGaData() {  
    let linker_param;
    const dictionary_var = {};
    try {
        const _ga_streamid = '_ga_0J2JG4B2P8';         
        const gaCookie = readCookie('_ga');
        if (gaCookie) {
            const _ga_var = gaCookie.split('.');
            const tmp = `${_ga_var[_ga_var.length - 2]}.${_ga_var[_ga_var.length - 1]}`;
            dictionary_var["_ga"] = tmp;
        } else {
            throw new Error("Cookie '_ga' NOT FOUND");
        }
        const gaStreamCookie = readCookie(_ga_streamid);
        if (gaStreamCookie) {
            const _ga_var2 = gaStreamCookie.split('.');
            dictionary_var[_ga_streamid] = `${_ga_var2.slice(2, 9).join('.')}`;
            console.log("GTM CC Output\n", dictionary_var);
            linker_param = window.google_tag_data.glBridge.generate(dictionary_var);
            console.log("GTM CC Output-\n", `?_gl=${linker_param}`);
        } else {
            throw new Error("Cookie '_ga_01VFLB3Q2Z' NOT FOUND");
        }       
    } catch (err) {
        console.log("Error occurred in Linker Parameter: ", err.message);
    }
    return linker_param ? `_gl=${linker_param}` : '';
}
// GA Linker - Function. This gets the _ga url paramter for cross-domain tracking
function getGALinker() {
	var linkerParam;
	try {
		if(typeof ga != 'undefined' && user_group_ua_property_id) {
			// live property ID
			var propertyID = user_group_ua_property_id;
			var targetTracker;
			var trackers = ga.getAll();
			for (var i = 0; i<trackers.length; i++) {
				// tracker is not null and has get function
				if (trackers[i] && typeof trackers[i].get != 'undefined') {
					// tracker property ID matches live property ID
					if (trackers[i].get('trackingId') == propertyID) {
						// set as target tracker
						targetTracker = trackers[i];
					}
				}
			}
			if (targetTracker) {
				// get linker paramater for url;
				linkerParam = targetTracker.get('linkerParam');
			}
		} else {
			// ga not defined
		}
	} catch (e) {
		// script error
	}
	return linkerParam;
}

function fullWin(imagine_id) {
	var win;

	// GA Linker - Attempt to get _ga
	var gaLink = '';
	if (typeof getGALinker != 'undefined' ) {
		var gaLinkResult = getGALinker();
		if (gaLinkResult && gaLinkResult.indexOf('_ga') >= 0) {
			gaLink = '?&'+gaLinkResult;
		}
	}

   var gaData ='';
  if (typeof gaData != 'undefined' ) {
		 gaData = getGaData();
			}
    
	//Mixpanel tracking
	mixpanel.track('LANDING_IMAGINE_CLICKED');

	// GA Linker - gaLink is added to redirect links
	if (offline_mode == true) {
		// offline mode
		win = window.location.href = offline_url + "?" + gaData;
	} else if (imagine_id == "#" || imagine_id == "" || imagine_id == undefined) {
		// imagine id hasn't been passed
		win = window.location.href = reimagine_url + "?" + gaData;;
	} else if (imagine_id.slice(-1) == "#") {
		// product redirect for posters
		win = window.location.href = poster_url + imagine_id.slice(0,-1) + "?" + gaData;;
	} else {
		// product redirect for reimagine
		win = window.location.href = reimagine_url + "product-redirect?productId=" + imagine_id + "&" + gaData;;
	}
	
	if (window.focus) {
		win.window.focus();
	}
}

function getProductPrice(imagine_id, shopify_id) {
	jQuery.ajax({
		url: "//rest.fujifilmimagine.com/api/product/" + imagine_id,
		dataType: "json",
		success: function(data, status, jqXHR) {
			if (typeof data.product[0] != undefined) {
				// api returned a result
				if (data.product[0].promo_price > 0 && data.product[0].price != data.product[0].promo_price) {
					// promo price exists
					$('#promo_' + shopify_id).show();
					$('#promo_' + shopify_id).html("&#36;" + data.product[0].price);
					$('#product_' + shopify_id).html("&#36;" + data.product[0].promo_price);
					$('#product_' + shopify_id).addClass("on-sale-wrapper");
					$('#expires_' + shopify_id).show();
					$('#expires_' + shopify_id).html(" ENDS " + data.product[0].promo_ends);
					$('#price_data_' + shopify_id).addClass('on-sale-wrapper');
					$('#offer_badge_' + shopify_id).show();
				} else {
					// no promo exists
					$('#promo_' + shopify_id).hide();
					// check if product price exists before overwriting
					if (data.product[0].price > 0) {
						$('#product_' + shopify_id).html("&#36;" + data.product[0].price);
					}
					$('#product_' + shopify_id).removeClass("on-sale-wrapper");
					$('#expires_' + shopify_id).hide();
					$('#price_data_' + shopify_id).removeClass('on-sale-wrapper');
					$('#offer_badge_' + shopify_id).hide();
				}
				sessionStorage.setItem("imagineid_" + imagine_id, JSON.stringify(data.product)); // stores product details to session for use by google tag manager
				//console.log(imagine_id + "," + shopify_id + "," + data.product[0].price + "," + data.product[0].promo_price);
			}
		},
		error: function(jqXHR, status) {
			//console.log(status);
		}
	});
}

function getDeliveryEstimate(postcode) {
	jQuery.ajax({
		url: "//rest.fujifilmimagine.com/api/delivery/" + postcode,
		dataType: "json",
		success: function(data, status, jqXHR) {
			if (typeof data.delivery[0] != undefined) {
				// api returned a result
                $('#delivery_form').hide();
                $('#delivery_submit').show();
                $('#delivery_region').html(data.delivery[0].suburb + " " + postcode + ", " + data.delivery[0].state);
                $('#delivery_instore').html(data.delivery[0].instore);
                $('#delivery_standard').html(data.delivery[0].standard);
                $('#delivery_express').html(data.delivery[0].express);
                $('#delivery').show();
				//console.log(imagine_id + "," + shopify_id + "," + data.product[0].price + "," + data.product[0].promo_price);
			}
		},
		error: function(jqXHR, status) {
			//console.log(status);
		}
	});
}

// Attempts to retrieve the product name from the session storage
function getImagineName(imagine_id, shopify_value) {
	var pa = JSON.parse(sessionStorage.getItem('imagineid_' + imagine_id));
	if (!pa) {
		result = shopify_value;
	} else {
		result = pa[0].name;
	}
	return result;
}

// Attempts to retrieve the product category from the session storage
function getImagineCat(imagine_id, shopify_value) {
	var pa = JSON.parse(sessionStorage.getItem('imagineid_' + imagine_id));
	if (!pa) {
		result = shopify_value;
	} else {
		result = pa[0].category;
	}
	return result;
}

// Attempts to retrieve and calculate the current price from the session storage
function getImaginePrice(imagine_id, shopify_value) {
	var pa = JSON.parse(sessionStorage.getItem('imagineid_' + imagine_id));
	if (!pa) {
		result = shopify_value;
	} else {
		result = pa[0].price;
	}
	return result;
}

// Attempts to retrieve and calculate the current price from the session storage
function getImaginePromoPrice(imagine_id, shopify_value) {
	var pa = JSON.parse(sessionStorage.getItem('imagineid_' + imagine_id));
	if (!pa) {
		result = shopify_value;
	} else {
		if (pa[0].promo_price > 0) {
			result = pa[0].promo_price;
		} else {
			result = pa[0].price;
		}
	}
	return result;
}

// Attempts to determine if product is on promo from the session storage
function isOnPromo(imagine_id) {
	var pa = JSON.parse(sessionStorage.getItem('imagineid_' + imagine_id));
	if (!pa) {
		result = 'False';
	} else {
		if (pa[0].promo_price > 0) {
			result = 'True';
		} else {
			result = 'False';
		}
	}
	return result;
}

// Retrieve product details from Shopify for a specific SKU
function getLastOrder() {
  	jQuery.ajax({
		url: "http://rest.fujifilmimagine.com/api/lastorder/" + user_group_id,
		//url: "lastorder.json",
		dataType: "json",
		success: function(data, status, jqXHR) {
			if (typeof data.order[0] != undefined) {
				// api returned a result
				if (data.order[0].product_id != "") {
                	$('#popup_where').html(data.order[0].suburb);
                	$('#popup_when').html(data.order[0].timesince);
                	getShopifyProduct(data.order[0].product_id);
					$('.openPopupOrders').click();
                }
			}
          console.log("Open");
		},
		error: function(jqXHR, status) {
			console.log(status);
		}
	});
}

// Retrieve product details from Shopify for a specific SKU
function getShopifyProduct(imagine_id) {
  	jQuery.ajax({
		url: "/search?type=product&view=sku&q=sku:" + imagine_id,
		dataType: "json",
		success: function(data, status, jqXHR) {
			if (typeof data.products[0] != undefined) {
				// api returned a result
				if (data.products[0] != "") {
					$('#popup_link').attr("href", data.products[1]);
					$('#popup_link').html(data.products[2]);
					$('#popup_image').attr("src",data.products[3]);
				}
			}
		},
		error: function(jqXHR, status) {
			console.log(status);
		}
	});
}
